<div
  class="bg-white rounded-2xl p-4 w-full"
  [ngClass]="type === 'collaborator' ? 'shadow' : ''"
>
  <ui-headline
    *ngIf="title"
    type="h20"
    mobile-type="h20"
    font-weight="semibold"
    text-color="neutrals-900"
  >
    {{ title }}
  </ui-headline>

  <div
    class="grid grid-cols-4 md:grid-cols-5 text-gray-400 text-sm font-medium border-b pb-2 mb-3"
    [ngClass]="title ? 'mt-6' : ''"
  >
    <span
      *ngFor="let header of headers; let i = index"
      [ngClass]="[
        'col-span-' + (header.colSpan || 1),
        i === 0 ? 'text-left' : 'text-center',
        'text-header',
      ]"
    >
      {{ header.label }}
    </span>
  </div>

  <div
    *ngFor="let item of items"
    class="grid grid-cols-4 md:grid-cols-5 items-center py-3 border-b last:border-b-0"
  >
    <!-- Colaborador o Distrito -->
    <div
      class="flex items-center gap-3"
      [ngClass]="'col-span-' + (headers[0].colSpan || 1)"
    >
      <ng-container *ngIf="type === 'collaborator'">
        <div
          class="flex flex-col justify-center items-center bg-[#fff6d9] box-border w-9 h-9 rounded-[36px]"
        >
          <ui-headline
            type="h14"
            mobile-type="h14"
            font-weight="bold"
            text-color="neutrals-900"
          >
            {{ getBadgeText(item) }}
          </ui-headline>
        </div>
        <div>
          <p class="font-semibold text-gray-800">{{ item.name }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="type === 'noCollaborator'">
        <p class="font-semibold text-gray-800">{{ item.name }}</p>
      </ng-container>
    </div>

    <!-- Ranking -->
    <div class="flex items-center gap-1 font-semibold justify-center">
      <span>{{ item.position }}</span>
      <span [ngClass]="getTrendIcon(item).color">
        {{ getTrendIcon(item).icon }}
      </span>
    </div>

    <div class="text-gray-800 font-medium text-center justify-center flex">
      {{ item.value1 }}
    </div>

    <div
      *ngIf="item.value2"
      class="text-gray-800 font-medium text-center justify-center flex"
    >
      {{ item.value2 }}
    </div>
  </div>
</div>
